import React from 'react';
import { useNavigate } from 'react-router-dom';
import './componenetStyle/Header.css';
import logo from '../LogoG3.png';
import logomini from '../LogoG3mini.png'
import burger from '../burgermenu.svg'

const Header = ({ uzytkownik, onWyloguj, onChangeMenuMobileVisibility }) => {
    const navigate = useNavigate();

    return (
        <header className="header">
            <div className="header-content">
                <picture>
                    <source media="(max-width: 768px)" srcSet={logomini} width={"60px"} height={"50px"}/>
                    <img src={logo} alt="Logo" />
                </picture>
                <div className="user-info">
                    <h3 className="user-name">{uzytkownik?.imie} {uzytkownik?.nazwisko}</h3>
                    <button className="profile-button" onClick={() => navigate('/uzytkownik')}>Mój profil</button>
                    <button className="logout-button" onClick={onWyloguj}>Wyloguj</button>
                    <button className='hamburger-menu' onClick={onChangeMenuMobileVisibility}>
                        <img src={burger} alt="hamburger-menu" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;

